(() => {
  const initialize = () => {
    const page = document.querySelector('.template-suffix--stream-ultra-x');
    if (!page) return;

    page.querySelectorAll('.custom-product-code-banner [data-count-down]').forEach((element) => {
      const end = Date.parse(element.dataset.countDown.replace(' ', 'T'));
      if (!Number.isFinite(end)) return;
      const update = () => {
        const remaining = Math.max(0, Math.floor((end - Date.now()) / 1000));
        const days = Math.floor(remaining / 86400);
        const hours = String(Math.floor(remaining / 3600) % 24).padStart(2, '0');
        const minutes = String(Math.floor(remaining / 60) % 60).padStart(2, '0');
        const seconds = String(remaining % 60).padStart(2, '0');
        element.textContent = `${element.dataset.endsIn || ''} ${days} ${element.dataset.daysTitle || ''} ${hours}:${minutes}:${seconds}`.trim();
        return remaining > 0;
      };
      if (update()) {
        const timer = window.setInterval(() => {
          if (!element.isConnected || !update()) window.clearInterval(timer);
        }, 1000);
      }
    });

    page.querySelectorAll('.custom-product-code-banner [data-coupon-code]').forEach((button) => {
      button.addEventListener('click', async () => {
        if (!navigator.clipboard) return;
        try {
          await navigator.clipboard.writeText(button.dataset.couponCode);
          if (button.dataset.copiedText) button.textContent = button.dataset.copiedText;
        } catch {
          // Keep the coupon code visible when clipboard permission is unavailable.
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
